import { Directive, ElementRef, Injector } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: 'mandae-ajs-main'
})
export class AJSMainDirective extends UpgradeComponent {
  constructor(elementRef: ElementRef, injector: Injector) {
    super('appMain', elementRef, injector);
  }
}
